import { Autocomplete } from "stimulus-autocomplete"

export default class extends Autocomplete {
  declare parentIdValue: string
  declare readonly hasParentIdValue: boolean

  declare parentParamValue: string
  declare readonly hasParentParamValue: boolean

  declare pathValue: string
  declare readonly hasPathValue: boolean

  declare readyValue: boolean
  declare readonly hasReadyValue: boolean

  declare submitOnEnterValue: boolean
  declare readonly hasSubmitOnEnterValue: boolean

  declare urlValue: string
  declare readonly hasUrlValue: boolean

  declare minLengthValue: number
  declare readonly hasMinLengthValue: boolean

  declare delayValue: number
  declare readonly hasDelayValue: boolean

  declare queryParamValue: string
  declare readonly hasQueryParamValue: boolean

  static values = {
    parentId: String,
    parentParam: String,
    path: String,
    ...super.values
  }

  connect() {
    super.connect()
  }

  // Overridden to select first result on the event of a successful show.
  // https://github.com/afcapel/stimulus-autocomplete/blob/main/src/autocomplete.js#L241
  open() {
    super.open()

    const item = this.sibling(true)
    if (item) { this.select(item) }
  }

  gotoResult({ detail: { value }}) {
    if (!this.hasPathValue) { return }

    const pathname = this.pathValue.replace(":id", value)
    window.location.pathname = pathname
  }

  // Overridden to append the parent object search param if available.
  // e.g. there is a search for drivers that is dependent on the selected
  // company, which is populated in the parentId hidden field.
  // In this case, the parentParam value would be "q[company_id_eq]" and
  // the parentId value would be "#drive_away_id". Hacky but we only do it once.
  // https://github.com/afcapel/stimulus-autocomplete/blob/e2115d641cb1d212573476cda602d69b62f483b5/src/autocomplete.js#L211
  buildURL(query: string): string {
    const url = new URL(this.urlValue, window.location.href)
    const params = new URLSearchParams(url.search.slice(1))

    if (this.hasParentParamValue && this.hasParentIdValue) {
      const parentInput = document.querySelector(this.parentIdValue) as HTMLInputElement | null

      if (!parentInput) {
        console.error(`Parent input was specified but no input could be found matching ${this.parentIdValue}`)
        return ""
      }
      else {
        const parentId = parentInput?.value
        params.append(this.parentParamValue, parentId)
      }
    }

    params.append(this.queryParamValue, query)
    url.search = params.toString()

    return url.toString()
  }
}
